import React, { useState } from 'react';
import { X, CheckCircle } from 'lucide-react';
import { MessageModal } from './MessageModal';
interface ApproveListingModalProps {
  isOpen: boolean;
  onClose: () => void;
  listingId: string;
  listingTitle: string;
}
export function ApproveListingModal({
  isOpen,
  onClose,
  listingId,
  listingTitle
}: ApproveListingModalProps) {
  const [remarks, setRemarks] = useState('');
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsMessageModalOpen(true);
    setTimeout(() => {
      onClose();
      setRemarks('');
    }, 2000);
  };
  return <>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-399">
        <div className="bg-white border border-gray-300 max-w-lg w-full shadow-lg" data-id="element-400">
          <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-401">
            <h3 className="font-bold text-lg flex items-center gap-2" data-id="element-402">
              <CheckCircle className="w-5 h-5 text-green-600" data-id="element-403" />
              Approve Listing
            </h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-404">
              <X className="w-5 h-5" data-id="element-405" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-4" data-id="element-406">
            <div className="p-3 bg-gray-50 border border-gray-200" data-id="element-407">
              <p className="text-sm text-gray-600" data-id="element-408">Listing ID:</p>
              <p className="font-bold font-mono" data-id="element-409">{listingId}</p>
              <p className="text-sm text-gray-600 mt-2" data-id="element-410">Title:</p>
              <p className="font-bold" data-id="element-411">{listingTitle}</p>
            </div>

            <div className="p-4 bg-green-50 border border-green-200" data-id="element-412">
              <h4 className="font-bold text-sm text-green-900 mb-2" data-id="element-413">
                Approval Checklist
              </h4>
              <div className="space-y-2 text-xs text-green-800" data-id="element-414">
                <label className="flex items-center gap-2" data-id="element-415">
                  <input type="checkbox" defaultChecked disabled className="w-4 h-4" data-id="element-416" />
                  All documents verified
                </label>
                <label className="flex items-center gap-2" data-id="element-417">
                  <input type="checkbox" defaultChecked disabled className="w-4 h-4" data-id="element-418" />
                  Legal clearances obtained
                </label>
                <label className="flex items-center gap-2" data-id="element-419">
                  <input type="checkbox" defaultChecked disabled className="w-4 h-4" data-id="element-420" />
                  Property details accurate
                </label>
                <label className="flex items-center gap-2" data-id="element-421">
                  <input type="checkbox" defaultChecked disabled className="w-4 h-4" data-id="element-422" />
                  Pricing within guidelines
                </label>
              </div>
            </div>

            <div data-id="element-423">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-424">
                Approval Remarks (Optional)
              </label>
              <textarea value={remarks} onChange={e => setRemarks(e.target.value)} placeholder="Add any notes or conditions for approval..." rows={4} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500 text-sm" data-id="element-425" />
            </div>

            <div className="flex justify-end gap-3 pt-4" data-id="element-426">
              <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-427">
                Cancel
              </button>
              <button type="submit" className="px-4 py-2 bg-green-600 text-white text-sm font-bold hover:bg-green-700" data-id="element-428">
                Approve Listing
              </button>
            </div>
          </form>
        </div>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Listing Approved" message={`Listing ${listingId} has been approved and is now live on the platform. The seller has been notified.`} type="success" data-id="element-429" />
    </>;
}